const getSearchFilterType = ({
  settings: {
    filters = []
  } = {}
}, type) => {
  if (!filters.length) return [];
  return filters.filter(({
    type: filterType
  }) => filterType === type);
};
export default getSearchFilterType;
//# sourceMappingURL=get-search-filter-type.js.map